<template>
  <el-table-column
    prop="type"
    sortable="custom"
    label="Irány"
    show-overflow-tooltip
    min-width="160"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.type === 'internal'">Belső</span>
      <span v-if="scope.row.type === 'out'">Kimenő</span>
      <span v-if="scope.row.type === 'in'">Bejövő</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'type',
  };
</script>
